module.exports = __webpack_public_path__ + "cbcef9d10b5c36024e10ae8d740b3168.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/final-logo.png
// module id = 474
// module chunks = 0